import styled from 'styled-components'


const LastCommentsStyle = styled.div.attrs( props => ({ className: props.className }))`
    background-color: var(--lightYellow);
    border-radius: 10px;
    width: var(--sp52x);
    padding:var(--sp4x);
    margin-top:var(--sp4x);
    overflow-wrap: anywhere;
    
    .single-comment {
        align-items: center;
        /* padding-bottom: var(--sp2-5x); */
        margin-top: var(--sp4x);

        .top {
            width: 100%;
            .imageCont {
                width: var(--sp5-5x);
                padding-top: var(--sp5-5x);
                border-radius:10px;
                overflow: hidden;
            }

            .info {
                margin-left:var(--sp2x);
                flex:1;

                .purple {
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;  
                    overflow: hidden;
                }
            }
        }

        .com {
            width: 100%;
            padding:var(--sp3x);
            background-color:#FFFEFC ;
            margin-top:var(--sp2x);
            border-radius: 10px;
        }
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSize}){
        padding:var(--sp3x);
        margin-top:var(--sp3x);
    }

    @media screen and (max-width:${(props) => props.theme.mediaQuery.TabletSizeS}){
        .single-comment {
            margin-top: var(--sp3x);
        }
        &:not(.inDebate){
            display: none !important;
        }
    }
`
export default LastCommentsStyle
